import React, { useState } from 'react';
import './Navbar.scss';
import {images} from '../../constants/';  //for easy access of images
import {HiMenuAlt4, HiX} from 'react-icons/hi';  //importing icons from lib we installed
import {motion} from 'framer-motion'; //importing framer-motion

const Navbar = () => {
  const [toggle, setToggle]= useState(false);  //creating a state
  return (
    <nav className='app__navbar'>
      <a className='app__navbar-logo' href={`#home`}> <img src={images.logo} alt="logo"/> </a>
      <ul className='app__navbar-links'>
        {['home','about','work','skills','contact'].map((item)=>(
          <li key={`link-${item}`} className='app__flex p-text'>
            <div />
            <a href={`#${item}`}>{item}</a>  {/*will help to directly move to that section */}
          </li>
        ))}
      </ul>
      <div className="app__navbar-menu">  {/*adding menu bar if width of screen is too small for viewing navbar */}
          <HiMenuAlt4 onClick={()=>setToggle(true)}/>
          {toggle && (  //if toggle is true then
            <motion.div
              whileInView={{x:[300,0]}}
              transition={{duration: 0.85, ease: "easeOut"}}>
                <ul className='app__navbar-links'>
                  <HiX onClick={()=>setToggle(false)}/>
                  {['home','about','work','skills','contact'].map((item)=>(
                    <li key={item}>
                      <a href={`#${item}`} onClick={()=>setToggle(false)}>{item}</a>  {/*if anything clicked close the sidebar*/}
                    </li>
                  ))}
                </ul>
            </motion.div>
          )}
      </div>
    </nav>
  )
}

export default Navbar
